import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import IP from "../../../images/IP_Image.png";
import IP from "../../../images/peck2.jpg";
import ph_logo from "../../../images/IFFFI_LOGO.png";
import ph_Nfdc from "../../../images/NFDC-Logo.png";
// import TajMahal from "../../../images/TajMahal.png";
import TajMahal from "../../../images/Group 706.png";
import "../Registration/Registration.css";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { getRequestGlobal, postRequestGlobal } from "../../../API/global";
import { postRequest } from "../../../API/IP";
import Snackbar from "@mui/material/Snackbar";
import pecock_vdo from "../../../images/peco.gif";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { REGULAR_EXPRESSION } from "../../../API/global";
import ReCAPTCHA from "react-google-recaptcha";
import { CAPTCHA_KEY_CLIENT_SIDE } from "../../../API/global";

const Registration = () => {
  const [organisationIdToText, setOrganisationIdToText] = useState({});
  const [loading, setLoading] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [emailError, setEmailError] = useState("");

  const [passwordError, setPasswordError] = useState("");

  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [showPasswordTwo, setShowPasswordTwo] = useState(false);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    mobile: "",
    email: "",
    password: "",
    password_confirmation: "",
    type_id: "",
    websiteUrl: "",
  });
  const festival_name = localStorage.getItem("param");
  if (festival_name === "creative-mind-tomorrow") {
    formData.type_id = 8;
  }

  const [captchaValue, setCaptchaValue] = useState(null);

  const [errors, setErrors] = useState({});
  const [passwordMatchError, setPasswordMatchError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    getRequestGlobal("ip_type_list", {})
      .then((data) => {
        setOrganisationIdToText(data.data);
      })
      .catch((error) => {
        console.error("Error fetching organisation types", error);
      });
  }, []);

  const handleClickShowPasswordOne = () => {
    setShowPasswordOne(!showPasswordOne);
  };

  const handleClickShowPasswordTwo = () => {
    setShowPasswordTwo(!showPasswordTwo);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const validateValues = (inputValues) => {
    const {
      email,
      first_name,
      last_name,
      mobile,
      password,
      password_confirmation,
      type_id,
    } = inputValues;
    let errors = {};

    if (!first_name) errors.first_name = "Mention your first name";
    if (!last_name) errors.last_name = "Mention your last name";
    // if (mobile.length < 10) errors.mobile = "Mobile number is too short";
    if (!mobile) {
      errors.mobile = "Enter your phone number";
    } else {
      if (mobile.length < 10) {
        errors.mobile = "Mobile number must be of 10 digits.";
      }
    }
    if (email.length < 10) errors.email = "Email is too short";
    if (!email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i))
      errors.email = "Invalid email format";
    if (password.length < 8) errors.password = "Password is too short";
    if (password_confirmation.length < 8)
      errors.password_confirmation = "Password confirmation is too short";
    if (!type_id) errors.type_id = "Select option from dropdown";

    return errors;
  };

  const validatePassword = (password) => {
    let data = REGULAR_EXPRESSION.test(password);
    if (data) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: "",
      }));
      return true;
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password:
          "Password must be at least 8 characters long and include at least 1 alphabet, 1 number, and 1 special character.",
      }));
      return false;
    }
  };
  const handleInputChange = async (event) => {
    const { name, value } = event.target;

    setErrors({
      ...errors,
      [name]: "",
    });

    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "mobile" ? value.replace(/\D/g, "").slice(0, 10) : value,
    }));

    if (name === "password_confirmation") {
      setPasswordMatchError(
        value !== formData.password ? "Passwords do not match" : ""
      );
    }

    if (name === "password") {
      validatePassword(value);
      setPasswordMatchError(
        formData.password_confirmation !== value ? "Passwords do not match" : ""
      );
    }

    if (name === "email") {
      await handleEmailVerify(value);
    }
  };

  const handleOrganisationData = (event) => {
    const { name, value } = event.target;

    setErrors({
      ...errors,
      [name]: "",
    });
    setFormData({ ...formData, [name]: parseInt(value) });
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateValues(formData);
    setErrors(formErrors);

    if (!captchaValue) {
      setAlertMessage("Please complete the CAPTCHA");
      setAlertSeverity("error");
      setAlertOpen(true);
      return;
    }

    const emailErrorMsg = await handleEmailVerify(formData.email);

    if (!emailErrorMsg) {
      return;
    }

    if (
      Object.keys(formErrors).length > 0 ||
      passwordError ||
      passwordMatchError
    ) {
      return;
    }

    setLoading(true);

    try {
      const payload = {
        ...formData,
        captcha: captchaValue,
      };

      const data = await postRequest("register", payload);

      if (data.status === true) {
        setAlertSeverity("success");
        setAlertMessage(data.message);
        setAlertOpen(true);

        setFormData({
          first_name: "",
          last_name: "",
          mobile: "",
          email: "",
          password: "",
          password_confirmation: "",
          type_id: "",
          websiteUrl: "",
        });
      } else {
        setAlertSeverity("error");
        setAlertMessage(data.message);
        setAlertOpen(true);
        setTimeout(() => {
          setAlertOpen(false); // Close the alert after 5 seconds (60000 milliseconds)
        }, 60000); // Adjust the timing as needed
      }
    } catch (error) {
      console.error("Error submitting form: ", error);
      setAlertMessage("Error submitting form. Please try again later.");
      setAlertSeverity("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleEmailVerify = async (value) => {
    let flag = true;

    let emailErrorMsg = "";
    if (!value.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)) {
      flag = false;
      emailErrorMsg = "Invalid email format";
    } else {
      try {
        const payload = { email: value };
        const response = await postRequestGlobal("verify-email", payload);
        if (response.data === 1) {
          flag = false;
          emailErrorMsg =
            "Email ID is already registered with us. Please sign up with another ID.";
        }
      } catch (error) {
        console.error("Error verifying email:", error);
      }
    }
    setEmailError(emailErrorMsg);
    // console.log({flag});

    return flag;
  };

  const handleKeyDown = (event) => {
    if (["e", "E", "+", "-", "."].includes(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <>
      {loading && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          bgcolor="#1c57687d"
          zIndex={1000}
        >
          <img src={pecock_vdo} alt="Loading..." />
          {/* <CircularProgress /> */}
        </Box>
      )}

      <div className="container-fluid px-0 w-100 h-100 overflow-x-hidden position-absolute">
        <div className="row h-100">
          <div className="col-sm-12 col-md-12 col-lg-6 h-100 response-phone">
            <img
              src={IP}
              className="mob-IP"
              alt="Indian Panorama"
              width="100%"
              height="100%"
            />
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6 second-box h-100 overflow-auto">
            <div className="logo-Phone">
              <a href={process.env.REACT_APP_HOME_URL}>
                <img
                  src={ph_logo}
                  className=""
                  alt="Indian Panorama"
                  width="85px"
                  height="auto"
                />
              </a>
              <img
                src={ph_Nfdc}
                className=""
                alt="Indian Panorama"
                width="85px"
                height="auto"
              />
            </div>
            {/* <p className="register me-3">
              Do you have an account ? {" "}
              <span>
                <Link to="/" className="log_in_now">
                  Log In Now
                </Link>
              </span>
            </p> */}
            <div className="container">
              <div className="row">
                <div className="col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
                <div className="col-sm-10 col-md-10 col-lg-10 col-xl-10">
                  <h1 className="welcome welcome_details">Welcome</h1>
                  {/* <p className="login_with_email">Enter your details to register</p> */}
                  <form encType="multipart/form-data">
                    {/* <div className="input_field" style={{ display: 'flex', gap: '10px' }}> */}
                    {/* <div style={{ flex: 1 }}> */}
                    <div className="input_field">
                      <TextField
                        variant="outlined"
                        fullWidth
                        placeholder="First Name"
                        InputProps={{
                          style: {
                            border: "1px solid #1c5768",
                            borderRadius: "5px",
                          },
                        }}
                        className="input_border"
                        name="first_name"
                        value={formData.first_name}
                        onChange={handleInputChange}
                      />
                      {errors.first_name && (
                        <p className="error text-danger">{errors.first_name}</p>
                      )}
                    </div>
                    {/* </div> */}

                    {/* <div style={{ flex: 1 }}> */}
                    <div className="input_field">
                      <TextField
                        variant="outlined"
                        fullWidth
                        placeholder="Last Name"
                        InputProps={{
                          style: {
                            border: "1px solid #1c5768",
                            borderRadius: "5px",
                          },
                        }}
                        className="input_border"
                        name="last_name"
                        value={formData.last_name}
                        onChange={handleInputChange}
                      />
                      {errors.last_name && (
                        <p className="error text-danger">{errors.last_name}</p>
                      )}
                    </div>
                    {/* </div> */}
                    {/* </div> */}

                    <div className="input_field">
                      <TextField
                        type="number"
                        variant="outlined"
                        fullWidth
                        placeholder="Number"
                        onKeyDown={handleKeyDown}
                        inputProps={{ maxLength: 10 }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              +91
                            </InputAdornment>
                          ),
                          // style: {
                          //   border: "1px solid #1c5768",
                          //   borderRadius: "5px",
                          // },
                        }}
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleInputChange}
                      />
                      {errors.mobile && (
                        <p className="error text-danger">{errors.mobile}</p>
                      )}
                    </div>

                    <div className="input_field">
                      <TextField
                        variant="outlined"
                        type="email"
                        fullWidth
                        placeholder="Email ID"
                        InputProps={
                          {
                            // style: {
                            //   border: "1px solid #1c5768",
                            //   borderRadius: "5px",
                            // },
                          }
                        }
                        className="input_border"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                      {/* {errors.email && <p className="error text-danger">{errors.email}</p>} */}
                      {emailError && (
                        <p className="error text-danger">{emailError}</p>
                      )}
                    </div>

                    <div className="input_field">
                      <TextField
                        variant="outlined"
                        fullWidth
                        placeholder="Password"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPasswordOne}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {showPasswordOne ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        className="input_border"
                        type={showPasswordOne ? "text" : "password"}
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        error={!!errors.password}
                        helperText={errors.password}
                      />
                    </div>

                    <div className="input_field">
                      <TextField
                        variant="outlined"
                        fullWidth
                        placeholder="Confirm Password"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPasswordTwo}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {showPasswordTwo ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        className="input_border"
                        type={showPasswordTwo ? "text" : "password"}
                        name="password_confirmation"
                        value={formData.password_confirmation}
                        onChange={handleInputChange}
                        error={!!passwordMatchError}
                        helperText={passwordMatchError}
                      />
                    </div>

                    <div className="input_field">
                      <FormControl fullWidth>
                        <Select
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          name="type_id"
                          value={formData.type_id}
                          onChange={handleOrganisationData}
                          style={{
                            border: "1px solid #1c5768",
                            borderRadius: "5px",
                          }}
                        >
                          <MenuItem value="" disabled>
                            Select an option
                          </MenuItem>
                          {Object.entries(organisationIdToText).map(
                            ([key, value]) => (
                              <MenuItem key={key} value={key}>
                                {value}
                              </MenuItem>
                            )
                          )}
                        </Select>
                        {errors.type_id && (
                          <p className="error text-danger">{errors.type_id}</p>
                        )}
                      </FormControl>
                    </div>

                    <div className="optional_option">
                      <p className="optional_text_details">
                        <span>Optional</span>
                      </p>
                    </div>

                    <div className="input_field">
                      <TextField
                        variant="outlined"
                        fullWidth
                        placeholder="Website url"
                        InputProps={
                          {
                            // style: {
                            //   border: "1px solid #1c5768",
                            //   borderRadius: "5px",
                            // },
                          }
                        }
                        className="input_border"
                        name="websiteUrl"
                        value={formData.websiteUrl}
                        onChange={handleInputChange}
                      />
                      {errors.websiteUrl && (
                        <p className="error text-danger">
                          Website URL is required
                        </p>
                      )}
                    </div>

                    <div className="input_field">
                      <ReCAPTCHA
                        sitekey={CAPTCHA_KEY_CLIENT_SIDE}
                        onChange={handleCaptchaChange}
                      />
                    </div>

                    <div className="register_details">
                      <button className="login" onClick={handleSubmit}>
                        Register
                      </button>
                    </div>
                    <p className="text-center mt-3">
                      Do you have an account ? &nbsp;&nbsp;
                    </p>
                    <p className="text-center mt-3">
                      <Link to="/" className="log_in_now">
                        {" "}
                        Log In Now
                      </Link>
                    </p>
                  </form>
                </div>
                <div className="col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
              </div>
            </div>
            <div>
              <img
                src={TajMahal}
                className="tajmahal"
                alt="Tajmal image"
                width="100%"
                height="100%"
              />
            </div>
          </div>
        </div>
        <Snackbar
          open={alertOpen}
          autoHideDuration={6000}
          onClose={() => setAlertOpen(false)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert severity={alertSeverity} variant="filled">
            {alertMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
};

export default Registration;
